import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import FrCloseSvg from '@src/svgs/fr-close-small.svg';
import { RecentSearchItem } from '../hooks/useRecentSearches/interfaces/recentSearchItem.interface';
import { Props } from './props';
import './styles.scss';

export const RecentSearches: FC<Props> = ({ recentSearches, removeRecentSearch, onQueryParamsSelect }) => {
  const generateKeyWords = (searchItem: RecentSearchItem): string[] => [
    ...(searchItem.searchPatterns ? searchItem.searchPatterns.map(({ pattern }) => pattern) : []),
    ...(searchItem.place ? [searchItem.place.name] : []),
    ...(searchItem.isRemote ? ['Remote'] : []),
    ...(searchItem.isRelocation ? ['Relocation'] : []),
    ...(searchItem.salaryRange ? [`€${searchItem.salaryRange[0]} - €${searchItem.salaryRange[1]}`] : []),
    ...(searchItem.seniorities ? searchItem.seniorities.map(({ name }) => name) : []),
    ...(searchItem.specialities ? searchItem.specialities.map(({ name }) => name) : []),
  ];

  return (
    <div className="verified-talent-carrousel-recent-searches">
      {recentSearches.map(searchItem => {
        return (
          <div
            className="verified-talent-carrousel-recent-searches__item"
            key={searchItem.id}
            onClick={() => onQueryParamsSelect(searchItem)}
          >
            <div className="verified-talent-carrousel-recent-searches__keywords">
              {generateKeyWords(searchItem).join(' • ')}
            </div>

            <Svg
              className="verified-talent-carrousel-recent-searches__remove-icon"
              onClick={(event: MouseEvent) => {
                event.stopPropagation();
                removeRecentSearch(searchItem.id);
              }}
              src={FrCloseSvg}
            />
          </div>
        );
      })}
    </div>
  );
};
